import { CheckmarkCircle } from '@prenuvo/halo-icon';
import { Container, Icon, List, ListItem, Typography } from '@prenuvo/halo-web';

const InclusionCriteria = () => (
  <Container className="my-4 border border-none bg-neutral-100 px-3 py-4">
    <Typography variant="h5" as="p" className="text-teal-500">
      Inclusion Criteria
    </Typography>
    <Typography variant="paragraph-sm" as="p" className="py-2 text-teal-500">
      Each subject must:
    </Typography>
    <List>
      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-green-700"
            source={CheckmarkCircle}
            aria-label="check mark circle"
          />
        }
        title={{
          children: 'Be over the age of 18 at the time of enrollment;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-green-700"
            source={CheckmarkCircle}
            aria-label="check mark circle"
          />
        }
        title={{
          children: 'Be able to read and understand provided procedural information for the study;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-green-700"
            source={CheckmarkCircle}
            aria-label="check mark circle"
          />
        }
        title={{
          children:
            'Be able and willing to follow all study procedures including proper breathing and body movement minimization while within the WB-MRI system;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-green-700"
            source={CheckmarkCircle}
            aria-label="check mark circle"
          />
        }
        title={{
          children:
            'Be willing and able to provide required clinical, demographic, medical history, and concomitant medications information;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-green-700"
            source={CheckmarkCircle}
            aria-label="check mark circle"
          />
        }
        title={{
          children:
            'Be able to provide financial payment in advance for reimbursement of the cost of the WB-MRI acquisition procedure and interpretation;',
        }}
      />

      <ListItem
        className={{
          root: 'bg-neutral-100',
        }}
        leadingContent={
          <Icon
            className="fill-current text-green-700"
            source={CheckmarkCircle}
            aria-label="check mark circle"
          />
        }
        title={{
          children: 'Complete all required consent procedures.',
        }}
      />
    </List>
  </Container>
);

export default InclusionCriteria;
